import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../../Tooltip';
import { useNavigate, useLocation } from 'react-router-dom';

const ForwardBackwardsButton = ({ flip }: { flip: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation(); // To trigger re-render on route changes
  const [t] = useTranslation(['navigation']);

  const idx = window.history.state?.idx;
  const canGoBack = idx !== undefined ? idx > 0 : window.history.length > 1;
  const canGoForward = idx !== undefined ? idx < window.history.length - 1 : false;

  const disabled = flip ? !canGoBack : !canGoForward;

  const navigateBack = () => {
    if (canGoBack) navigate(-1);
  };

  const navigateForward = () => {
    if (canGoForward) navigate(1);
  };

  return (
    <Tooltip title={flip ? t('Go back') : t('Go forward')}>
      <button
        className='bg-black p-2 rounded-full h-4/6 aspect-square h-8 mobile-visible'
        onClick={flip ? navigateBack : navigateForward}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <img
          alt={flip ? 'Backwards' : 'Forward'}
          src={`${process.env.PUBLIC_URL}/images/forward.svg`}
          className={`w-full h-full ${flip ? 'rotate-180' : ''}`}
        />
      </button>
    </Tooltip>
  );
};

export default ForwardBackwardsButton;
